/**
 * 常量
 */
export function getStartDate(date: Date, before: number) {
  const start = new Date(new Date(date.getTime() - before * 24 * 60 * 60 * 1000).toLocaleDateString()).getTime();
  return start;
}

export function getEndDate(date: Date, before: number) {
  const end = new Date(new Date(date.getTime() - before * 24 * 60 * 60 * 1000).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
  return end;
}

/*
 * 'yyyy-MM-dd'
 * 毫秒值转日期字符串
 */
export function getDateString(millisecond: number) {
  return new Date(millisecond + 8 * 60 * 60 * 1000).toJSON().replace(/T.*/, '');
}

/*
 * 获取某月的天数
 */
export function getMonthDays(currentDate: Date) {
  return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();
}

/*
 * 'yyyy-MM-dd ~ yyyy-MM-dd'
 * 以某个时间点为准，获取上月起始时间结束时间、本月起始时间结束时间开始时间和下月起始时间结束时间;
 * 上月开始结束： n = 1
 * 本月开始结束： n = 0
 * 下月开始结束： n = -1
 */
export function getMonthPeriod(currentDate: Date, n: number) {
  let monthDate;
  switch (n) {
    case 1:
      monthDate = new Date(currentDate.getTime() - currentDate.getDate() * 24 * 60 * 60 * 1000);
      break;
    case 0:
      monthDate = currentDate;
      break;
    case -1:
      monthDate = new Date(currentDate.getTime() + (getMonthDays(currentDate) - currentDate.getDate() + 1) * 24 * 60 * 60 * 1000);
      break;
    default:
      break;
  }
  const dateStart = getDateString(new Date(monthDate.getFullYear(), monthDate.getMonth(), 1).getTime());
  const dateEnd = getDateString(new Date(monthDate.getFullYear(), monthDate.getMonth(), getMonthDays(monthDate)).getTime());
  return dateStart + ' ~ ' + dateEnd;
}

/*
 * 'yyyy-MM-dd ~ yyyy-MM-dd'
 * 以某个时间点为准
 * 上周开始结束： t = 1
 * 本周开始结束： t = 0
 * 下周开始结束： t = -1
 */
export function getWeeKPeriod(currentDate: Date, t: number) {
  let dateString = '';
  switch (t) {
    case 1:
      dateString = getWeekDate(currentDate, 7) + ' ~ ' + getWeekDate(currentDate, 1);
      break;
    case 0:
      dateString = getWeekDate(currentDate, 0) + ' ~ ' + getWeekDate(currentDate, -6);
      break;
    case -1:
      dateString = getWeekDate(currentDate, -7) + ' ~ ' + getWeekDate(currentDate, -13);
      break;
    default:
      break;
  }
  return dateString;
}

/*
 * 'yyyy-MM-dd'
 * 以某个时间点为准，快递获取某一星期的时间
 * 上周开始-结束： n = 7 ~ n = 1
 * 本周开始-结束： n = 0 ~ n = -6
 * 下周开始-结束： n = -7 ~ n = -13
 */
function getWeekDate(currentDate: Date, n: number) {
  // 此处必须深复制一个时间对象，因为下方的setDate会改变时间
  const _date = new Date(currentDate.valueOf());
  let year = _date.getFullYear();
  // 因为月份是从0开始的,所以获取这个月的月份数要加1才行
  let month = _date.getMonth() + 1;
  const day = _date.getDay();
  // 判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
  if (day !== 0) {
    n = n + (day - 1);
  } else {
    n = n + day;
  }
  if (day) {
    // 这个判断是为了解决跨年的问题
    if (month > 1) {
      month = month;
    }
    // 这个判断是为了解决跨年的问题,月份是从0开始的
    else {
      year = year - 1;
      month = 12;
    }
  }
  _date.setDate(_date.getDate() - n);
  return getDateString(_date.getTime());
}
